import React from 'react';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from 'material-ui/Table';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import moment from 'moment';
import {
  changePage,
  changeRowsPerPage
} from '../actions/LogsActions';


class LogList extends React.Component {

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  render() {
    const {
      classes,
      logList,
      t,
      page,
      rowsPerPage
    } = this.props;

    let sliceToDisplay = logList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <Paper className={classes.root}>
        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Level</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Organization</TableCell>
                <TableCell>Start date</TableCell>
                <TableCell>End date</TableCell>
                <TableCell>Comment</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Launch Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logList.length < 1 && 
              <TableRow key="No logs">
                <TableCell component="th" scope="row">
                    No logs yet
                  </TableCell>
              </TableRow>
              }
              {
                sliceToDisplay.map(log => (
                <TableRow key={log._id} hover>
                  <TableCell component="th" scope="row">
                    {log.level}
                  </TableCell>
                  <TableCell>
                    {log.action}
                  </TableCell>
                  <TableCell style={{cursor: "pointer"}}>
                    {log.organization ?
                      (
                        <a
                          target="blank"
                          style={{textDecoration: 'none', color: "inherit"}}
                          href={"/organizations/read/"+ log.organization._id}
                        >
                          {log.organization.name}
                        </a>
                      ) :
                      "-"
                    } 
                  </TableCell>
                  <TableCell>
                    {log.startDate? log.startDate : "-"}
                  </TableCell>
                  <TableCell>
                    {log.endDate? log.endDate : "-"}
                  </TableCell>
                  <TableCell>
                    {log.comment}
                  </TableCell>
                  <TableCell style={{cursor: "pointer"}}>
                    {log.user ?
                      (
                        <a
                          target="blank"
                          style={{textDecoration: 'none', color: "inherit"}}
                          href={"/users/read/"+ log.user.user_id.replace("auth0|","")}
                        >
                          {log.user.username}
                        </a>
                      ) :
                      "-"
                    } 
                  </TableCell>
                  <TableCell>
                    {moment(log.creation_date).format("LLLL")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
              component="div"
              count={logList.length}
              labelDisplayedRows={({ from, to, count }) =>
                from + "-" + to + t(" of ") + count
              }
              labelRowsPerPage={t("RowsPerPage")}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page"
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page"
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </div>
      </Paper>
    );
  }
}

const mapStateToProps = ({ logsReducer }) => {
  const { page, rowsPerPage} = logsReducer;
  return { page, rowsPerPage};
};

const mapDispatchToProps = {
  changePage,
  changeRowsPerPage
}

export default (
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LogList)
);


// WEBPACK FOOTER //
// ./src/components/LogList.js